"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getId = exports.getLanguageStringFromIso = exports.loadAsyncScript = exports.formDateString = exports.formTimeString = exports.toDoubleDigit = exports.millisecondsToSeconds = exports.secondsToMilliseconds = exports.MILLISECONDS_IN_SECOND = void 0;
var iso_639_1_1 = __importDefault(require("iso-639-1"));
__exportStar(require("./EventManager"), exports);
exports.MILLISECONDS_IN_SECOND = 1000;
var secondsToMilliseconds = function (seconds) {
    return seconds * exports.MILLISECONDS_IN_SECOND;
};
exports.secondsToMilliseconds = secondsToMilliseconds;
var millisecondsToSeconds = function (milliseconds) {
    return milliseconds / exports.MILLISECONDS_IN_SECOND;
};
exports.millisecondsToSeconds = millisecondsToSeconds;
var toDoubleDigit = function (number) {
    return number.length === 1 ? "0" + number : number;
};
exports.toDoubleDigit = toDoubleDigit;
var getLiveDate = function (milliseconds) {
    return new Date(milliseconds);
};
var formTimeString = function (milliseconds, showHours, isLive) {
    if (isLive === void 0) { isLive = false; }
    var date = new Date();
    date.setHours(0, 0, 0, milliseconds);
    if (isLive)
        date = getLiveDate(milliseconds);
    var minutes = date.getMinutes().toString();
    var seconds = exports.toDoubleDigit(date.getSeconds().toString());
    if (showHours) {
        return date.getHours().toString() + ":" + exports.toDoubleDigit(minutes) + ":" + seconds;
    }
    return minutes + ":" + seconds;
};
exports.formTimeString = formTimeString;
var formDateString = function (time) {
    var date = new Date(time);
    return exports.toDoubleDigit(date.getDate().toString()) + "/" + exports.toDoubleDigit((date.getMonth() + 1).toString()) + "/" + exports.toDoubleDigit(date.getFullYear().toString());
};
exports.formDateString = formDateString;
var loadAsyncScript = function (source) {
    return new Promise(function (resolve, reject) {
        var scriptElement = document.createElement('script');
        scriptElement.src = source;
        scriptElement.async = true;
        scriptElement.onload = function () {
            return resolve();
        };
        scriptElement.onerror = function () {
            return reject();
        };
        document.body.appendChild(scriptElement);
    });
};
exports.loadAsyncScript = loadAsyncScript;
var getLanguageStringFromIso = function (isoCode) {
    var formattedIsoCode = isoCode.toLowerCase();
    switch (formattedIsoCode) {
        case 'und':
            return 'Undefined';
        case 'default':
            return 'Default';
        default:
            return iso_639_1_1.default.validate(formattedIsoCode)
                ? iso_639_1_1.default.getName(formattedIsoCode)
                : formattedIsoCode;
    }
};
exports.getLanguageStringFromIso = getLanguageStringFromIso;
var lastId = 0;
var getId = function (prefix) {
    if (prefix === void 0) { prefix = 'id'; }
    lastId += 1;
    return "" + prefix + lastId;
};
exports.getId = getId;
__exportStar(require("./timeHelpers"), exports);
//# sourceMappingURL=index.js.map